module.exports = __webpack_public_path__ + "img/slp-chart.fb88070b.png";